/* © CNES */
/**
 * Controls to allow user actions on map.
 * @param children each control to display.
 * @returns Element.
 */

import { useContext } from 'react';
import Floater from 'react-floater';
import { ConfigContext } from '../../../context/ConfigContext';
import {
  StartGuidContent,
  startGuidStyle,
} from '../../shared/startGuidContent/StartGuidContent';
import './Controls.scss';

const Controls = ({ children }: { children: any }) => {
  const context = useContext(ConfigContext);

  return (
    <Floater
      open={context.isGetStarted}
      content={
        <StartGuidContent
          title="Pilot the map"
          body="Create search areas using drawing tools <br/> <br/>Switch background from a selection of map layers"
          icon="globe_uk.png"
        />
      }
      placement="auto-end"
      offset={-10}
      styles={{
        ...startGuidStyle,
      }}
      target=".map-controls"
    >
      <div className="map-controls">{children}</div>
    </Floater>
  );
};
export default Controls;
